import styled from 'styled-components';

// Corpo padded compartilhado pelas modais do rateio.
//
// Existe porque o .ant-modal-body do projeto tem `padding: 0 !important`
// (Components/UI/Modal/styles.ts): cada modal aplica o seu próprio respiro. Sem
// isso o conteúdo encosta nas bordas e o `overflow: hidden` do corpo chega a
// cortar a borda direita dos campos.
//
// 30px na horizontal é o valor usado pelos outros modais da plataforma
// (UpdateConta, CancelUpdatePlan). Fica num arquivo só para os dois modais novos
// não divergirem quando alguém ajustar o espaçamento.
export const ModalBody = styled.div`
  padding: 25px 30px 30px;
`;

export default ModalBody;
